<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="researchAreas"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    to="/manage/edit/researchArea/add"
            ><v-icon class="mr-2">mdi-plus-thick</v-icon
            >{{ $t("button.newItem") }}</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            text
            class="mr-2"
            color="primary"
            :to="`/manage/edit/researchArea/edit/${item.id}`"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.closed="{ item }">
          <v-icon class="ml-6" v-if="item.closed" color="red">
            mdi-lock
          </v-icon>
          <v-icon v-else class="ml-6" color="grey">
            mdi-lock-open-outline
          </v-icon>
        </template>
        <template v-slot:item.deprecated="{ item }">
          <v-icon class="ml-2" v-if="item.deprecated" color="red">
            mdi-delete
          </v-icon>
          <v-icon v-else class="ml-2" color="grey">
            mdi-delete-empty-outline
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,
      search: "",
      researchAreas: []
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name." + this.$i18n.locale
        },
        {
          text: this.$t("table.closed"),
          value: "closed"
        },
        {
          text: this.$t("table.deprecated"),
          value: "deprecated"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/researchArea";
      axios
        .get(path)
        .then(response => {
          this.researchAreas = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/researchArea/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.researchAreas.indexOf(item);
            this.researchAreas.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    }
  }
};
</script>
